import React from 'react';
import { FadeIn } from './FadeIn';
export function Proof() {
  return <section className="bg-blush py-24 md:py-32 px-6" data-id="element-165">
      <div className="max-w-reading mx-auto text-center" data-id="element-166">
        <FadeIn data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-serif text-forest mb-10" data-id="element-168">
            What changes in 7 days
          </h2>
          <div className="text-xl md:text-2xl font-serif text-charcoal/90 leading-relaxed space-y-8" data-id="element-169">
            <p data-id="element-170">
              By next Sunday night, that 8:00 PM knot in your stomach will be
              replaced by a calm, quiet confidence.
            </p>
            <p data-id="element-171">
              You'll go to bed knowing exactly what to do, what to wear, and
              exactly what to say "No" to.
            </p>
            <p className="text-forest font-medium italic" data-id="element-172">
              You aren't just surviving Monday; you're reclaiming your Sunday.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}